'use strict';

const $ = require('jquery');

const Selector = {
  passwordToggleButton: '.js-pwd-toggler',
  passwordInput: '.js-password-input'
};

const togglePwd = (event) => {
  event.preventDefault();

  const $catalyst = $(event.currentTarget);
  const targetSelector = $catalyst.data('target');
  const $targets = $(targetSelector);
  const $label = $catalyst.find('.js-show-label');
  const isIconType = $label.data('type') === 'showPassIconLabel';

  if (!$targets.length) return;

  const shouldShowPassword = $targets.first().attr('type') === 'password';
  $targets.each((_, input) => {
    $(input).attr('type', shouldShowPassword ? 'text' : 'password');
  });

  if (isIconType) return;
  $label.text(shouldShowPassword ? $catalyst.data('hideLabel') : $catalyst.data('showLabel'));
};

const bindEvent = () => {
  const $toggleButtons = $(Selector.passwordToggleButton);

  $toggleButtons.each((_, button) => {
    $(button).on('click', (e) => {
      togglePwd(e);
    });

    $(button).on('keydown', (e) => {
      if (e.key === 'Enter') togglePwd(e);
    });
  });
};

module.exports = function() {
  if ($(Selector.passwordToggleButton).length > 0) bindEvent();
};
